export default function Roadmap() {
  return (
    <section className="roadmap padding-top padding-bottom" id="roadmap">
      <div className="container">
        <div className="section-header section-header--middle">
          <div className="section-header__content">
            <div className="section-header__titlebar">
              <p className="section-header__subtitle"> Explore</p>
              <h2 className="section__header__title">Phase I Roadmap</h2>
            </div>
          </div>
        </div>
        <div className="roadmap__wrapper2">
          <div className="row gy-4 gy-md-0 gx-5">
            <div className="col-lg-6 offset-lg-6 mb-3">
              <div
                className=" roadmap__item2 ms-md-4 aos-init"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="roadmap__item2-inner roadmap-completed">
                  <div className="roadmap__item2-content">
                    <div className="roadmap__item2-header">
                      <h4>Project Development</h4>
                      <p>01</p>
                    </div>
                    <p>
                      Project development began many months ago when Quantum
                      Energy was thought up as a concept. A team was assembled,
                      a plan was put together, the brainstorming began, and the
                      code started to flow. Two unique smart contracts have been
                      produced since then, that will act as the first phase of
                      Quantum Energy.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-3">
              <div
                className=" roadmap__item2 ms-auto me-md-4 aos-init"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="roadmap__item2-inner roadmap-completed">
                  <div className="roadmap__item2-content">
                    <div className="roadmap__item2-header">
                      <h4>Website Creation</h4>
                      <p>02</p>
                    </div>
                    <p>
                      Website development was initiated in tandem with the smart
                      contract development, to ensure maximum workflow and an
                      optimized UX design. Version 1 of the website will be
                      launched with a fully functioning user dashboard and Dapp.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 offset-lg-6 mb-3">
              <div
                className="roadmap__item2 ms-md-4  aos-init"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="roadmap__item2-inner roadmap-completed">
                  <div className="roadmap__item2-content">
                    <div className="roadmap__item2-header">
                      <h4>Quantum Networking</h4>
                      <p>03</p>
                    </div>
                    <p>
                      The team has leveraged their vast network reach to build
                      an effective foundation of project supporters, ranging
                      from callers and whale groups, to a variety of widespread
                      investors. All code is thoroughly checked in this stage
                      and comprehensive stress testing is carried out.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-3">
              <div
                className="roadmap__item2 ms-auto me-md-4  aos-init"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="roadmap__item2-inner roadmap-completed">
                  <div className="roadmap__item2-content">
                    <div className="roadmap__item2-header">
                      <h4>Token Fair Launch </h4>
                      <p>04</p>
                    </div>
                    <p>
                      The token QTE and stealth launch phase. All smart
                      contracts will be published, verified on etherscan, and
                      then the adding of liquidity will be initiated through
                      Uniswap. Once these steps have been taken, the project
                      will officially have bypassed it's stealth launch phase,
                      and public marketing will begin. Official links and the
                      token smart contract address will be shared on all
                      socials.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 offset-lg-6 mb-3">
              <div
                className="roadmap__item2 ms-md-4  aos-init"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="roadmap__item2-inner">
                  <div className="roadmap__item2-content">
                    <div className="roadmap__item2-header">
                      <h4>Staking Rewards</h4>
                      <p>05</p>
                    </div>
                    <p className="pb-3">
                      Hodlers of the Quantum Energy token can increase their
                      holdings via two ways. The first method requires
                      minimal effort on your part. Simply stake your QTE
                      tokens to
                      start accruing airdrops from the genesis block. Your
                      staking rewards keep accumulating and can be claimed at
                      any time from your dashboard. You may also unstake your tokens at anytime without penalty. The longer you stake, the higher your rewards.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-6 mb-3">
              <div
                className="roadmap__item2 ms-auto me-md-4  aos-init"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="roadmap__item2-inner">
                  <div className="roadmap__item2-content">
                    <div className="roadmap__item2-header">
                      <h4>Yield Farming</h4>
                      <p>06</p>
                    </div>
                      <p> The second
                      method to increase your token share is through our farm.
                      By adding liquidity to the ETH/QTE token pair on Uniswap via our Dashboard(do not use Uniswap directly as it will show as a sell) 
                      you will received uniswap liquidity tokens (fondly
                      referred to as UNI-V2 tokens), which you can then stake on
                      our farm to unlock additional APY. You will receive
                      rewards via our yield farming protocol, which will last
                      for 6 months only. After 6 months, the farm will have paid
                      out its rewards in full to liquidity providers. The end date is May 2, 2023.
                    </p>
                   
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 offset-lg-6 mb-3">
              <div
                className="roadmap__item2 ms-md-4  aos-init"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="roadmap__item2-inner">
                  <div className="roadmap__item2-content">
                    <div className="roadmap__item2-header">
                      <h4>Iterate & Grow</h4>
                      <p>07</p>
                    </div>
                    <p>
                      After the successful launch of the token aggressive
                      marketing began, and further development to create an
                      overall Quantum Energy ecosystem suite was put into
                      motion. The goal is to create a self-reliant perpetual
                      environment of dApps that utilize QTE.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
//   <h4>LP Farming Rewards</h4>
//   <p>06</p>
// </div>
// <p>
//  The second
//   method to increase your token share is through our farm.
//   By adding liquidity to the ETH/QTE token pair on Uniswap via our Dashboard(do not use Uniswap directly as it will show as a sell) 
//   you will received uniswap liquidity tokens (fondly
//   referred to as UNI-V2 tokens), which you can then stake on
//   our farm to unlock additional APY. You will receive
//   rewards via our yield farming protocol, which will last
//   for 6 months only. After 6 months, the farm will have paid
//   out its rewards in full to liquidity providers.
// </p>
}
